import { render, staticRenderFns } from "./DropsBreakDown.vue?vue&type=template&id=e5520494"
import script from "./drops-break-down.ts?vue&type=script&lang=ts&external"
export * from "./drops-break-down.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports